<!--  -->
<template>
  <div class='LoginBody'>
    <div class="loginMain" v-if="isLogin">
      <div>
        <img src="@/assets/loginLogo.png" class="loginLogo" alt="">
        <div>欢迎来到二类医疗器械商家入驻</div>
      </div>

      <div class="loginMsg">
        <div class="title">
          <div>手机号密码登录</div>
        </div>
        <div class="message">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item prop="phone">
              <div>
                <el-input v-model="form.phone" placeholder="请输入手机号">
                  <img src="@/assets/user.png" width="20" class="inputMsg" slot="prefix" alt="">
                </el-input>
              </div>
            </el-form-item>
            <el-form-item prop="password">
              <div>
                <el-input v-model="form.password" @keyup.enter.native="doSubmit" type="password" placeholder="请输入密码">
                  <img src="@/assets/lock.png" class="inputMsg" width="20" slot="prefix" alt="">
                </el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="rememberMe">
          <el-checkbox v-model="checked">记住我</el-checkbox>
        </div>
        <div class="submit">
          <el-button type="primary" size="medium" @click="doSubmit">登录</el-button>
        </div>
        <div class="zhuce canClick" @click="isLogin = !isLogin">
          <span>还没账户？</span>
          <span style="color: #D54B53">立即注册</span>
        </div>
      </div>
    </div>
    
    <div v-else class="registMsg">
      <register @changeState="isLogin = !isLogin"/>
      <div class="zhuce canClick" @click="isLogin = !isLogin">
        <span>已注册，</span>
        <span style="color: #D54B53">马上登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import Register from '../components/register.vue'

export default {
  components: {
    Register
  },
  data() {
    let validateMobile = (rule, value, callback) => {
      if(!value)return callback(new Error('请输入手机号'))
      if(!/^1\d{10}$/.test(value))return callback(new Error('请输入正确的手机号'))
      callback()
    }
    return {
      isLogin: true,

      checked: false,
      form: {
        phone: '',
        password: '',
      },

      rules: {
        phone: [{validator: validateMobile, trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}],
      }
    }
  },
  computed: {},
  watch: {
    checked() {
      if(this.checked) {
        localStorage.phone = this.form.phone
        localStorage.password = this.form.password
      } else {
        localStorage.removeItem('phone')
        localStorage.removeItem('password')
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if((localStorage.phone && localStorage.phone != "undefined") || (localStorage.password && localStorage.password != "undefined")) {
      this.form.phone = localStorage.phone
      this.form.password = localStorage.password
      this.checked = true
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  
  },
  methods: {
    doSubmit() {
      this.$refs.form.validate((v) => {
        if(!v)return
        this.$http.post('/api/WebUser/Login', {
          phone: this.form.phone,
          pwd: this.form.password
        }).then(res => {
          this.$store.commit('LOG_IN', { token: res.data.access_Token })
        })
      })
    }
  },
}
</script>
<style lang='scss'>
.LoginBody {
  // position: absolute;
  // top: 0;
  // left: 0;
  // right: 0;
  // bottom: 0;
  margin-top: -54px;
  background: #F0F3F7;
  border: 1px solid #F0F3F7;
  // background-size: 100% auto;
  // z-index: -1;
  .inp {
    width: 95%;
  }
  .loginMain {
    width: 416px;
    height: 491px;
    background: rgba($color: #fff, $alpha: 0.9);
    margin-top: 50vh;
    margin-left: 50vw;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    // opacity: 0.9;
    align-items: center;
    padding: 24px;
    box-sizing: border-box;
    font-size: 16px;
    > :first-child {
      margin-top: 8px;
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .loginLogo {
        height: 38px;
        width: auto;
        margin-bottom: 16px;
      }
    }
    .loginMsg {
      > div {
        margin-top: 24px;
      }  
      > .title {
        display: flex;
        margin-top: 30px;
        color: #177fc8;
        > div {
          padding: 10px 0;
          border-bottom: 2px solid #177fc8;
        }
      }
      .message {
        > div {
          margin-top: 24px;
        }
      }
      .inputMsg {
        margin: 10px 9px;
      }
    }
    .el-input__inner {
      padding-left: 40px;
    }
  }

  .submit {
    button {
      width: 100%;
      letter-spacing: 10px;
    }
  }
  .registMsg {
    width: 600px;
    // height: 834px;
    background: #fff;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 50vw;
    padding: 24px;
    border-radius: 4px;

    transform: translateX(-50%);
    > div {
      margin-top: 24px;
    }
    .ercode {
      margin-top: 30px;
      width: 208px;
      height: 208px;
      background: #ddd;
    }
    .tishi {
      color: #666;
      font-size: 16px;
      text-align: center;
      line-height: 24px;
    }
  }
  
  .zhuce {
    width: 100%;
    font-size: 14px;
    text-align: right;
  }
  .el-input {
    background: #fff;
    border-radius: 4px;
  }
}
</style>